module.exports = __webpack_public_path__ + "img/icon-social-pinterest.a6aca79.svg";